<script lang="ts">
    import { Button, Col } from "sveltestrap";
    import { Basic, BasicExamples, Infoalert, Successalert, Warningalert, WithTitlealert } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import swal from 'sweetalert';
    const handleAlert =(id)=>{
        if(id === 1){
            swal("Hello world!");
        }
        else if(id === 2){
            swal("Here's the title!", "...and here's the text!");
        }
        else if(id === 3){
            swal("Good job!", "You clicked the button!", "success");
        }
        else if(id === 4){
            swal("Click on either the button or outside the modal.")
            .then((value) => {
            swal(`The returned value is: ${value}`);
            });
        }
        else if(id === 5){
            swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this imaginary file!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            })
            .then((willDelete) => {
            if (willDelete) {
                swal("Poof! Your imaginary file has been deleted!", {
                icon: "success",
                });
            } else {
                swal("Your imaginary file is safe!");
            }
            });
        }
    }
</script>
<Col sm="12">
    <Card headerTitle={BasicExamples} cardBodyprops="btn-showcase" cardHeaderprops="pb-0">
      <div slot="contentbody">
        <Button color="primary" id=1 on:click={()=>handleAlert(1)} class="sweet-1" >{Basic}</Button>
        <Button color="primary" id=2 on:click={()=>handleAlert(2)} class="sweet-2" >{WithTitlealert}</Button>
        <Button color="success" id=3 on:click={()=>handleAlert(3)} class="sweet-3" >{Successalert}</Button>
        <Button color="info" id=4 on:click={()=>handleAlert(4)} class="sweet-4" >{Infoalert}</Button>
        <Button color="warning" id=5 on:click={()=>handleAlert(5)} class="sweet-5" >{Warningalert}</Button>
      </div>
    </Card>
</Col>